import { FabricObject } from 'fabric';

/**
 * Keep the designer on Fabric 7 while preserving the left/top coordinate system
 * that the legacy canvas layout code was written around.
 */
export function applyFabricCompatibilityDefaults(): void {
  FabricObject.ownDefaults.objectCaching = false;
  FabricObject.ownDefaults.originX = 'left';
  FabricObject.ownDefaults.originY = 'top';
}
